import React from "react";
import styles from "./index.module.scss";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { convertDateTime } from "Helpers/date";
import moment from "moment";
import { useFormikContext } from "formik";

function InternalNoteAccordion(props) {
  const [expanded, setExpanded] = React.useState(true);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const formik = useFormikContext();
  return (
    <div className={`${styles.InternalNotesAccordianStyle}`}>
      <Accordion
        expanded={expanded}
        onChange={() => setExpanded(!expanded)}
        className={`${styles.MuiAccordion}`}
      >
        <AccordionSummary
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          className={`${styles.summary} Custom-Accordian`}
        >
          <div
            className={`${styles.iconArrow} ${
              expanded ? styles.iconRotation : ""
            }`}
          >
            <KeyboardArrowUpIcon style={{ color: "#ffffff" }} />
          </div>
          <p className={`${styles.author}`}>{props.data.author}</p>
          <p className={`${styles.time}`}>
            {props.data.time && props.data.time !== null
              ? convertDateTime(moment(props.data.time).toISOString(), 'iso', "ccc LLL dd, yyyy, hh:mm a", "", formik?.values?.orderTimezone)
              : ""}
          </p>
        </AccordionSummary>
        <AccordionDetails className={`${styles.desc}`}>
          {props.data.ans}
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

export default InternalNoteAccordion;
